import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@avanta/shared/components/ui/Button';
import { MessageStatus } from '@avanta/shared/constants/chat';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMessagesStore } from '@avanta/shared/stores/chat/messages';
import type { OptimisticMessage } from '@avanta/shared/types/chat';

interface RetryMessageButtonProps {
  message: OptimisticMessage;
}

export const RetryMessageButton = ({
  message,
}: RetryMessageButtonProps): React.ReactElement | null => {
  const { retryMessage } = useMessagesStore();
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  if (message.status !== MessageStatus.failed || !message.tempId) return null;

  const handleRetry = (): void => {
    void retryMessage(message.channelId, message.tempId ?? '');
  };

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handleRetry}
      className="text-red-500 hover:text-red-600 hover:bg-red-50 p-1 h-auto text-xs flex items-center gap-1"
      title={t('Chat.Messages.retry.action')}
    >
      <RotateCcw className="size-3" />
      {t('Chat.Messages.retry.action')}
    </Button>
  );
};
